import { AuthAxios } from "./AuthAxios";
import { oauthConfig } from "../OauthConfig";

const baseUrl = `${oauthConfig.authority}/api/components`

export const ComponentsApi = {

    // updateComponent: async (component: SalesReportToJSON) => {

    //     return await AuthAxios.post(`/sales-report/update`, component)
    // },

    getComponent: async () => {

        return await AuthAxios.get(`${baseUrl}/`);
    },

    saveComponent: async (component: object) => {
        const url = `${baseUrl}/save`
        return await AuthAxios.post(url, component)
    },

    updateComponent: async (component: any) => {
        const url = `${baseUrl}/${component.id}/update`
        return await AuthAxios.post(url, component)
    },

    deleteComponent: async (id: string) => {
        return await AuthAxios.post(`${baseUrl}/${id}/delete`)
    },

    duplicateComponent: async (id: string) => {
        return await AuthAxios.post(`/sales-report/${id}/duplicate`)
    },

}